import { useQuery } from '@tanstack/react-query';
import { ProfileReplyApi } from 'api/ApiHelper';
import { repliesQueryKey } from 'queries/reply/queryKey';

export const useGetProfileReplyCountsQuery = (profileId: number) =>
  useQuery({
    queryKey: repliesQueryKey.profileReplyCount(profileId),
    queryFn: () => ProfileReplyApi.getProfileReplyCount(profileId),
    staleTime: 1000 * 60,
  });
